<template lang="pug">
BriqCheckbox(
  :value="value"
  @input="e => $emit('input', e)"
  :label="customField.FieldName"
  :required="!customField.Optional"
  name="Enabled"
  :help="customField.Description"
  :error="error"
  data-test-id="custom-field-checkbox"
  )
</template>

<script>
import { validateProps } from '@v/util/propValidators.js'

export default {
  name: 'CustomFieldCheckbox',
  props: {
    customField: {
      type: Object,
      validator: validateProps(['FieldCode', 'FieldName', 'Optional', 'Description']),
    },
    value: { type: Boolean, required: true },
    error: String,
  },
}
</script>
